import { ReactComponent as ResetIcon } from "./svg/reset.svg";
import "./IconResetCircle.scss";

type Props = {
  disabled?: boolean;
};

export const IconResetCircle = ({ disabled = false }: Props) => {
  return (
    <span className={`icon-reset-circle${disabled ? " icon-reset-circle--disabled" : ""}`}>
      <ResetIcon />
    </span>
  );
};
